<template>
  <v-container grid-list-lg>
    <app-splash/>
    <v-layout justify-center>
      <v-flex xs12 lg10 xl8>
        <v-card>
          <v-card-text class="pa-4">
            <v-layout>
              <v-flex>
                <span class="body-1">
                  <span v-html="$t('login.disclaimer')"></span>
                </span>
              </v-flex>
            </v-layout>
            <v-layout justify-end class="mt-3">
              <v-btn color="primary"
                     :block="$vuetify.breakpoint.smAndDown"
                     @click="login">
                {{ $t('login.buttons.anonLogin') }}
              </v-btn>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import AppSplash from '@viewsupport/AppSplash';
import { mapActions } from 'vuex';

export default {
  components: { AppSplash },
  computed: {
    _pageTitle () {
      return this.$t('login.title');
    }
  },
  methods: {
    ...mapActions('user', ['login'])
  }
};
</script>
